import { createSelector } from 'reselect';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getApmCurrentOrderQuantity } from './getApmCurrentOrderQuantity';
import { getPartsMadeForJob } from './getPartsMadeForJob';
import { getLatestJob } from './getLatestJob';

/**
 * Returns meter display values { partsMadeForJob, partsRequired } for the
 * bottom-left PartsRequiredMeter on the Part Count page.
 *
 * For APM ERP flow: uses program-event order quantity.
 * For all other flows: uses job total and latest job quantity.
 */
export const getPartCountMeterDisplay = createSelector(
  [
    getIsApmERPJobFlow,
    getApmCurrentOrderQuantity,
    getPartsMadeForJob,
    getLatestJob,
  ],
  (isApmERPJobFlow, apmCurrentOrderQuantity, partsMadeForJob, latestJob) => {
    if (isApmERPJobFlow && apmCurrentOrderQuantity != null) {
      return {
        partsMadeForJob: apmCurrentOrderQuantity.completedQuantity,
        partsRequired: apmCurrentOrderQuantity.finishQuantity,
      };
    }

    return {
      partsMadeForJob,
      partsRequired: latestJob?.quantity,
    };
  }
);
